<template>
  <span
    class="rounded bg-ontick-blue-900 px-3 py-1 text-center text-ontick-blue-50"
  >
    {{ type === "PORTFOLIO" ? "Portfólio" : "Estratégia" }}
  </span>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: true,
    },
  },
};
</script>

<style></style>
